import "./Servicios.css";
import Servicio from "../atoms/Servicio";
import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-cards";
import "swiper/css/free-mode";

import services from "../../data/services";

export const Servicios = () => {
  const useWindowWidth = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener("resize", handleResize);

      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);

    return windowWidth;
  };

  const windowWidth = useWindowWidth();

  return (
    <div id="servicios">
      <div className="servicios-container">
        <div className="servicios-titles">
          <h1>Nuestras Servicios</h1>
          <sub>
            Ofrecemos <b>múltiples beneficios y propuestas</b>, todas ellas
            diseñadas y pensadas para vos, y para que tu día a dia sea más{" "}
            <b>seguro, independiente y digno de ser disfrutado.</b>
          </sub>
        </div>
      </div>
      <div className="servicios-container">
        {windowWidth <= 1160 ? (
          <Swiper
            spaceBetween={-30}
            slidesPerView={"auto"}
            centeredSlides={true}
            modules={[Pagination]}
            pagination={{ clickable: true }}
          >
            {Object.entries(services).map(([key, service], index) => (
              <SwiperSlide style={{ display: "flex", maxWidth: "400px" }}>
                <Servicio key={index} service={service} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <>
            {Object.entries(services).map(([key, service], index) => (
              <Servicio key={index} service={service} />
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Servicios;
